import React from "react";
import medal from "../../images/hireDeveloper/medal.svg";
import clock from "../../images/hireDeveloper/clock.svg";
import experience from "../../images/hireDeveloper/experience.svg";
import userCheck from "../../images/hireDeveloper/user-check.svg";
import halfTime from "../../images/hireDeveloper/half-time.svg";
import conversation from "../../images/hireDeveloper/conversation.svg";

const remoteTeam = [
  {
    images: medal,
    heading: "Among the top 1% of developers with the best skills",
    title: "We hire the best developers to work for the best global companies.",
  },
  {
    images: clock,
    heading: "Access to full-time work (40 hours/week)",
    title:
      "We allow part-time work during a short transition period, but you'll need to transition to full-time quickly.",
  },
  {
    images: experience,
    heading: "3-5+ years of industry experience",
    title:
      "If you have worked as a senior software engineer, you'll be having remote job opportunities with the Hire Remote Team.",
  },
  {
    images: userCheck,
    heading: "3-6 hours availability for tests & interviews",
    title:
      "Take our tests & interviews designed by Hire Remote Team's industry experts.",
  },
  {
    images: halfTime,
    heading: "4 hours overlap with time zone",
    title:
      "Our clients are primarily operating globally in tier 1 countries and hence we require a 4-hour overlap with their timezone.",
  },
  {
    images: conversation,
    heading: "Fluent English and Proactiveness",
    title:
      "We seek communicators who are skilled at handling remote work challenges and can overcome them through effective communication.",
  },
];

const WhoApply = () => {
  return (
    <>
      <section className="whoApplySection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  <span>Who Can Apply To</span> The Hire Remote Team?
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            {remoteTeam.map((each, i) => (
              <div
                className="col-md-4 col-sm-6 mb-5"
                data-aos="zoom-in"
                key={i}
              >
                <div className="details">
                  <div className="images">
                    <img src={each.images} alt="Hire Flutter Developer" />
                  </div>
                  <h5>{each.heading}</h5>
                  <p>{each.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhoApply;
